/* eslint-disable react/jsx-props-no-spreading */
import { makeStyles, TextField as MUITextField } from "@material-ui/core";
import cx from "classnames";
import { useField, useFormikContext } from "formik";
import PropTypes from "prop-types";
import React from "react";

const useStyles = makeStyles(theme => ({
  textField: {
    "& > .MuiOutlinedInput-root": {
      backgroundColor: theme.palette.background.paper
    },
    "& .MuiOutlinedInput-inputMultiline": {
      padding: 8
    }
  }
}));

const TextField = ({ name, label, number, submitOnChange, className, ...other }) => {
  const classes = useStyles();
  const [{ onChange: fieldOnChange, value: fieldValue, ...field }, meta] = useField(name);
  const { submitForm } = useFormikContext();
  const isInError = Boolean(meta.touched) && Boolean(meta.error);
  const onChange = e => {
    fieldOnChange(e);
    if (submitOnChange) {
      submitForm();
    }
  };
  return (
    <MUITextField
      margin="normal"
      type={number ? "number" : "text"}
      error={isInError}
      helperText={isInError && meta.error}
      label={label}
      onBlur={() => field.onBlur(field.name)}
      onChange={onChange}
      value={fieldValue || ""}
      {...field}
      {...other}
      className={cx(classes.textField, className)}
    />
  );
};

TextField.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  name: PropTypes.string.isRequired,
  number: PropTypes.bool
};

TextField.defaultProps = {
  number: false
};

export default TextField;
